module.exports = __webpack_public_path__ + "img/VehiculoDatos.49aa47ce.svg";